import { render, staticRenderFns } from "./GoogleCallback.vue?vue&type=template&id=0ef1b43c&"
import script from "./GoogleCallback.vue?vue&type=script&lang=js&"
export * from "./GoogleCallback.vue?vue&type=script&lang=js&"
import style0 from "./GoogleCallback.vue?vue&type=style&index=0&id=0ef1b43c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports